import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { T } from '@sm/intl';
import { Toast } from '@wds/toast';
export const COPY = {
  toastTitle: {
    id: 'OpenEndedCoding.OpenEndedCodingModal.toastTitle',
    defaultMessage: "Sorry, that didn't work",
    description: '[Type: Header][Vis: med] - title for open ending coding error'
  },
  toastBody: {
    id: 'OpenEndedCoding.OpenEndedCodingModal.toastBody',
    defaultMessage: 'Please try again.',
    description: '[Type: Header][Vis: med] - body for open ending coding error'
  }
};
const ErrorToast = ({
  show,
  autoClose = false,
  dismissible = false,
  onClose
}) => {
  return _jsxs(Toast, {
    show: show,
    autoClose: autoClose,
    dismissible: dismissible,
    color: "warning",
    onClose: onClose,
    children: [_jsx(Toast.Title, {
      children: _jsx(T, {
        desc: COPY.toastTitle
      })
    }), _jsx(Toast.Body, {
      children: _jsx(T, {
        desc: COPY.toastBody
      })
    })]
  });
};
export default ErrorToast;